import { render } from "./SocialPostPreview.vue?vue&type=template&id=a265308c&scoped=true&ts=true"
import script from "./SocialPostPreview.vue?vue&type=script&lang=ts"
export * from "./SocialPostPreview.vue?vue&type=script&lang=ts"

import "./SocialPostPreview.vue?vue&type=style&index=0&id=a265308c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a265308c"]])

export default __exports__